import { createApp } from 'vue';
import router from './router.js';
import App from './App.vue'
import GM from './GlobalMethods.js';

const app = createApp(App);
app.use(router);
app.mixin(GM);
app.mount('#app');
